/**
 * Utility for handling API requests
 */

// Base API URL - replace with your actual API endpoint
const API_BASE_URL = 'https://n8n.trackitfaster.click/webhook/landing';

/**
 * Send data to the specified endpoint
 * 
 * @param {string} endpoint - API endpoint path
 * @param {object} data - The data to send
 * @param {string} method - HTTP method (default: POST)
 * @returns {Promise} - Promise that resolves with the response data
 */
export const sendData = async (endpoint, data, method = 'POST') => {
  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    });
    
    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error(`API Error: ${error.message}`);
    throw error;
  }
};

/**
 * Utility for sending all form data to a single endpoint
 */

// The specific endpoint for all form submissions
const FORM_ENDPOINT = 'https://n8n.trackitfaster.click/webhook/landing';

/**
 * Send all collected form data to the endpoint - simplified version
 * @param {object} data - The essential form data to send
 * @returns {Promise} - Promise that resolves with the response
 */
export const submitAllData = async (data) => {
  try {
    // Simplified data object with only essential information
    const essentialData = {
      contactInfo: data.contact,
      businessInfo: data.waitlist,
      selectedAgents: data.selectedAgents.map(agent => agent.name || agent),
      keyInteractions: data.userInteractions?.slice(-10) || [], // Keep only the 10 most recent interactions
      submittedAt: new Date().toISOString()
    };
    
    console.log('Submitting essential data:', essentialData);
    
    const response = await fetch(FORM_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(essentialData)
    });
    
    if (!response.ok) {
      throw new Error(`Submission failed with status ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Form submission error:', error);
    throw error;
  }
};

/**
 * Track user interactions without sending to backend
 * This function only stores the events in memory to be sent later
 */
export const trackEvent = (eventName, eventData = {}) => {
  // This is just a stub - we'll collect this data in LandingPage component
  // and only send it with the final submission
  return {
    eventName,
    eventData,
    timestamp: new Date().toISOString()
  };
};
